var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPath150(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.891,
    height: 163.807,
    viewBox: "0 0 130.891 163.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M1351.231,812.568h-95.338a17.776,17.776,0,0,0-17.777,17.776V958.6a17.776,17.776,0,0,0,17.777,17.776h95.338a17.775,17.775,0,0,0,17.776-17.776V830.344a17.775,17.775,0,0,0-17.776-17.776m-51.877,99.005h-36.9a3.82,3.82,0,1,1,0-7.64h36.9a3.82,3.82,0,0,1,0,7.64m31.49-27.492h-68.392a3.82,3.82,0,1,1,0-7.641h68.392a3.82,3.82,0,0,1,0,7.641m0-27.48h-68.392a3.82,3.82,0,1,1,0-7.64h68.392a3.82,3.82,0,0,1,0,7.64",
    transform: "translate(-1238.116 -812.568)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath150);
export default __webpack_public_path__ + "static/media/Path 150.d7e3043757e91308d1a7b6880e118943.svg";
export { ForwardRef as ReactComponent };